import RoleIndex from "@/components/role/RoleIndex.vue";
import RoleAdd from "@/components/role/RoleAdd.vue";
import RoleDetail from "@/components/role/RoleDetail.vue";
import RoleEdit from "@/components/role/RoleEdit.vue";
import RoleUpload from "@/components/role/RoleUpload.vue";
import RoleCopy from "@/components/role/RoleCopy.vue";

let routesRoleAccess= [
    {
        path: '',
        meta: {
          title: "List Role Access",
        },
        name: "RoleIndex",
        component: RoleIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Role Access",
        },
        name: "RoleAdd",
        component: RoleAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Role Access",
        },
        name: "RoleDetail",
        component: RoleDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Role Access",
        },
        name: "RoleEdit",
        component: RoleEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload Role Access",
        },
        name: "RoleUpload",
        component: RoleUpload
    },
    {
        path: 'copy/:id',
        meta: {
          title: "Copy Role Access",
        },
        name: "RoleCopy",
        component: RoleCopy
    },
    
]

export default routesRoleAccess
  